import { Category, Geometry, Participant, StatusName } from '@range.io/basic-types'
import StringTypes from '@range.io/basic-types/src/string-types.js'
import { tagged } from '@range.io/functional'
import PropTypes from 'prop-types'

// prettier-ignore
const EnrichedCollaboration = tagged('EnrichedCollaboration', {
    assigneeIsOnline    : 'Boolean?',
    isArchived          : 'Boolean',
    
    assigneeId          : StringTypes.OptionalId,
    canvasId            : StringTypes.Id,
    categoryId          : StringTypes.Id,
    createdById         : StringTypes.OptionalId,
    featureId           : StringTypes.Id,
    geometryId          : StringTypes.Id,
    id                  : StringTypes.Id,
    organizationId      : StringTypes.Id,
    projectId           : StringTypes.Id,
    statusNameId        : StringTypes.OptionalId,
    
    assigneeEmail       : 'String?',
    assigneeAvatarUrl   : 'String?',
    assigneeName        : 'String?',
    categoryName        : 'String',
    description         : 'String?',
    identifier          : 'String?',
    name                : 'String',
    projectIdentifier   : 'String',
    sheetLabel          : 'String',
    
    dueDate             : 'Object?',
    mostRecentUpdateDate: 'Object?',
    createdAt           : 'Object',
    storageVersion      : 'Object?',
    
    assignee            : 'Participant?',
    category            : 'Category',
    status              : 'StatusName',
    geometry            : 'Geometry',
    
    tagNameIds          : StringTypes.Ids,
    followerIds         : StringTypes.Ids,
    
    tagNames            : '[String]',             // this is misnamed; these are NOT tagNames, just strings
    
    createdByName       : 'String',
    projectName         : 'String',
    url                 : 'String'
})

// prettier-ignore
EnrichedCollaboration.propTypes = {
    assigneeIsOnline    : PropTypes.bool,
    isArchived          : PropTypes.bool.isRequired,
    
    assigneeId          : PropTypes.string,
    canvasId            : PropTypes.string.isRequired,
    categoryId          : PropTypes.string.isRequired,
    createdById         : PropTypes.string.isRequired,
    featureId           : PropTypes.string.isRequired,
    geometryId          : PropTypes.string.isRequired,
    id                  : PropTypes.string.isRequired,
    organizationId      : PropTypes.string.isRequired,
    projectId           : PropTypes.string.isRequired,
    statusNameId        : PropTypes.string.isRequired,
    
    assigneeEmail       : PropTypes.string,
    assigneeAvatarUrl   : PropTypes.string,
    assigneeName        : PropTypes.string,
    categoryName        : PropTypes.string.isRequired,
    description         : PropTypes.string.isRequired,
    identifier          : PropTypes.string.isRequired,
    name                : PropTypes.string.isRequired,
    projectIdentifier   : PropTypes.string.isRequired,
    sheetLabel          : PropTypes.string.isRequired,
    
    dueDate             : PropTypes.object,
    mostRecentUpdateDate: PropTypes.object,
    createdAt           : PropTypes.object.isRequired,
    storageVersion      : PropTypes.object.isRequired,
    
    assignee            : tagged.typeIsOptional(Participant),
    category            : tagged.typeIsRequired(Category),
    status              : tagged.typeIsRequired(StatusName),
    geometry            : tagged.typeIsRequired(Geometry),
    
    tagNameIds          : PropTypes.arrayOf(PropTypes.string).isRequired,
    followerIds         : PropTypes.arrayOf(PropTypes.string).isRequired,
    
    tagNames            : PropTypes.arrayOf(PropTypes.string).isRequired,
    
    createdByName       : PropTypes.string.isRequired,
    projectName         : PropTypes.string.isRequired,
    url                 : PropTypes.string.isRequired,
}

export default EnrichedCollaboration
